

// Arbeitsbreite der Verwaltung (/orders), lokal pro Browser in localStorage.
// Sentinel VOLLBREITE = volle Fensterbreite (max-width: none).
export const VOLLBREITE = 2000

export function adminBreiteLaden() {
    return parseInt(localStorage.getItem('adminbreite')) || 1200
}

export function adminMaxWidth(breite) {
    return breite >= VOLLBREITE ? 'none' : breite + 'px'
}

export function uppername(input) {
    try {
        return input.split(', ').map(word => 
            word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        ).join(', ');
    } catch (error) {
        return input;
    }
}